function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import { Input, CurrencyInput } from "../../../helperComponents";
import { CurrencyTypes } from "../../../utils/data";
import { formatValue } from "../../../utils/currency";
import LightVehicles from "./LightVehicles";

var HeavyVehicles = function HeavyVehicles(props) {
  var _onChange = props.onChange,
      itemAsegurado = props.itemAsegurado,
      index = props.index;
  var comercial_sector = itemAsegurado.comercial_sector,
      is_in_conflict_zone = itemAsegurado.is_in_conflict_zone;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody cntRamo"
  }, /*#__PURE__*/React.createElement(LightVehicles, {
    index: index,
    itemAsegurado: itemAsegurado,
    onChange: _onChange,
    showHeavyVehiclesType: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement("div", {
    className: "row col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Rubro"), /*#__PURE__*/React.createElement(Input, {
    classNameInput: "form-control",
    placeholder: "Escriba Rubro...",
    value: comercial_sector || "",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        comercial_sector: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "\xBFTrabaja en zona de conflicto?"), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-check-inline usoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "inlineRadioOptions2",
    id: "inlineRadio1",
    value: "option1",
    checked: is_in_conflict_zone,
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        is_in_conflict_zone: true
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Si"), /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "inlineRadioOptions2",
    id: "inlineRadio2",
    value: "option2",
    checked: !is_in_conflict_zone,
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        is_in_conflict_zone: false
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "No"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Valor Comercial"), /*#__PURE__*/React.createElement(CurrencyInput, {
    currency: CurrencyTypes.UF,
    className: "form-control",
    defaultValue: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.comercial_value,
    onValueChange: function onValueChange(value) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        comercial_value: formatValue(value, 3)
      }));
    }
  }))));
};

export default HeavyVehicles;